

export function truncate(text, length = 50, suffix = '...') {
  if (text.length > length) {
    return `${text.substring(0, length)}${suffix}`;
  } else {
    return text;
  }
}
